import { IActionBase, IAction } from "../types"

export const SET_ARRAY = "SET_ARRAY"
export const CREATE_NEW_DATA = "CREATE_NEW_DATA"
export const CHANGE_ARRAY_SIZE = "CHANGE_ARRAY_SIZE"

const createArray = (size: number): number[] =>
    Array(size)
        .fill(0)
        .map(() => Math.ceil(Math.random() * size))

const initialState: number[] = createArray(50)

export default function array(state = initialState, action: IActionBase): number[] {
    switch (action.type) {
        case SET_ARRAY:
            return (action as IAction<number[]>).payload
        case CREATE_NEW_DATA:
            return createArray(state.length)
        case CHANGE_ARRAY_SIZE:
            return createArray((action as IAction<number>).payload)
        default:
            return state
    }
}
